import { SaveOutlined } from '@ant-design/icons';
import type { SelectProps } from 'antd';
import { Button, Checkbox, Input, Select, Tooltip } from 'antd';
import { ROUTES } from 'base/routes/routes';
import LoadingScreen from 'base/ui/components/LoadingScreen/loadingScreen';
import { cloneDeep } from 'lodash';
import { observer } from 'mobx-react';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { HiQuestionMarkCircle } from 'react-icons/hi';
import { IoArrowBackCircle } from 'react-icons/io5';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { DropdownEquipment } from 'services/commonDate_services';
import { DataInputRouting } from 'services/routing_services';
import { User } from 'services/user_services';
import { commonDatePresenter, commonDateStore, routingPresenter, routingStore } from 'stores/root_store';
import { URL_HOME } from 'utils/constants';
import { getUserSession } from 'utils/localStorageHelper';

const createRoutingOrTransfer = () => {
  return observer(() => {
    const navigate = useNavigate();

    // Kiểm tra phân quyền
    try {
      const pagePermissions = () => {
        // Kiểm tra đường dẫn
        // check phân quyền bằng đường dẫn
        // kiểm tra url của web để tìm page id => dùng page id để tìm quyền của trang
        const path = window.location.pathname;
        const user = getUserSession() as User;
        const filteredData = user.webPermission.pageModel.filter((item) => {
          const itemNames = item.pageUrl.split(' ');
          return itemNames.some((name) => path.includes(name));
        });

        if (filteredData.length) {
          const permission = user.webPermission.pagePermissionModel.filter(
            (item) => item.pageId === filteredData[0].pageId,
          );
          if (permission.length) {
            if (permission.findIndex((item) => item.functionId === 'CREATE') === -1) {
              navigate('/' + ROUTES.MASTER_DATA.ROUTING_TRANSFER.LINK);
            }
          }
        }
      };
      pagePermissions();
    } catch (error) {
      console.log(error);
    }

    const {
      register,
      trigger,
      setValue,
      watch,
      handleSubmit,
      reset,
      formState: { errors },
    } = useForm<any>({
      defaultValues: {
        isRequired: 'true'
      }
    });
    //==========================STATE===================//
    // Loading
    const [loading, setLoading] = useState(false);
    // Load equipment
    const [listEquipment, setListEquipment] = useState<DropdownEquipment[]>([]);
    // show equipmentProduction and unit
    const [equipmentAndUnit, setEquipmentAndUnit] = useState({
      equipment: 0,
      unit: '',
    });
    // Hidden button save
    const [hiddenButtonSave, setHiddenButtonSave] = useState(false);
    // Check button save and save continue
    let isSaveAndContinue = false;
    //==========================FUNCTION===================//
    // Call api list dropdown equipment
    const getListDropdownEquipment = async (keyword: string) => {
      await commonDatePresenter.getDropdownEquipment(commonDateStore, keyword);
      if (commonDateStore.dropdownEquipment.isSuccess) {
        setListEquipment(commonDateStore.dropdownEquipment.data);
      }
    };

    // Call api create routing
    const handleCreateRouting = async (data: DataInputRouting) => {
      const dataCreate = cloneDeep(data)
      Object.assign(dataCreate, { isRequired: JSON.parse(data.isRequired) })
      await routingPresenter.createRouting(routingStore, dataCreate);
      if (routingStore.createResponse.isSuccess) {
        toast.success(routingStore.createResponse.message);

        // Reset data form input
        reset();
        setEquipmentAndUnit({
          equipment: 0,
          unit: '',
        });
        handleClearEquipmentList();
        // Redirect to search page routing (Button Save)
        if (!isSaveAndContinue) {
          setTimeout(() => {
            navigate('/MasterData/Routing');
          }, 2000);
        }
      } else {
        toast.error(routingStore.createResponse.message);
      }
    };
    // Call api first access
    useEffect(() => {
      getListDropdownEquipment('');
    }, []);

    // Change select requipment
    const handleSelectChange = (value: string[]) => {
      const selectedOptions = value.map((v) => listEquipment.find((o) => o.value === v)) as DropdownEquipment[];

      if (selectedOptions.length > 0) {
        // Set quipment and unit to show
        setEquipmentAndUnit({
          equipment: selectedOptions[0].equipmentProduction,
          unit: selectedOptions[0].unit,
        });
      } else {
        // Set quipment and unit to show
        setEquipmentAndUnit({
          equipment: 0,
          unit: '',
        });
      }

      //   Check item selected >1
      if (selectedOptions.length > 1) {
        const firstUnit = selectedOptions[0]?.unit;
        const differentUnit = selectedOptions.find((o) => o.unit !== firstUnit);

        if (differentUnit) {
          toast.warning('Không cùng đơn vị công suất. Vui lòng chọn lại!');
          setHiddenButtonSave(true);
          // Delete value before send form
          setValue('equipmentList', []);
          return;
        }
        // Sumn equipment production
        const sumEquipmentProduction = selectedOptions.reduce((pre, current) => pre + current.equipmentProduction, 0);
        setEquipmentAndUnit({
          equipment: sumEquipmentProduction,
          unit: selectedOptions[0].unit,
        });
      }

      const selectedKeys = selectedOptions.map((o) => o.key);

      setValue('equipmentList', selectedKeys);
      setHiddenButtonSave(false);
    };

    // Clear selected change equipment list
    const handleClearEquipmentList = () => {
      setEquipmentAndUnit({ equipment: 0, unit: '' });
      setHiddenButtonSave(false);
    };

    const handleSaveForm = async (data: DataInputRouting) => {
      await handleCreateRouting(data);
    };

    const isPrepareEquipment = watch('isPrepareEquipment')
    const isCM = watch('isCM')

    useEffect(() => {
      if (isPrepareEquipment) {
        setValue('isCM', false)
      }
    }, [isPrepareEquipment]);
    useEffect(() => {
      if (isCM) {
        setValue('isPrepareEquipment', false)
      }
    }, [isCM]);

    return (
      <>
        <div className="w-full py-3 px-5">
          {loading && <LoadingScreen />}
          <div className="mb-2 flex justify-between items-center">
            <div className="flex items-center">
              <h3 className="text-md font-bold text-gray-800 uppercase">Thêm mới danh mục công đoạn/chuyền</h3>
              <Link
                to={'/MasterData/Routing'}
                className="flex items-center text-xs text-primary cursor-pointer ml-3 font-medium whitespace-nowrap"
              >
                <IoArrowBackCircle className="mr-2 text-base text-gray-500" />
                Quay lại
              </Link>
            </div>
            {!hiddenButtonSave ? (
              <div className="flex space-x-2">
                <Button
                  className="!flex !items-center !text-white !bg-[#0052cc] hover:!bg-blue-600 !border-[#0052cc] !rounded-[3px] !text-default font-[400] !px-2.5 !py-1 text-center !h-7"
                  icon={<SaveOutlined />}
                  onClick={() => {
                    isSaveAndContinue = false;
                    handleSubmit(handleSaveForm)();
                  }}
                >
                  Lưu
                </Button>
                <Button
                  className="!flex !items-center !text-white !bg-[#0052cc] hover:!bg-blue-600 !border-[#0052cc] !rounded-[3px] !text-default font-[400] !px-2.5 !py-1 text-center !h-7"
                  icon={<SaveOutlined />}
                  onClick={() => {
                    isSaveAndContinue = true;
                    handleSubmit(handleSaveForm)();
                  }}
                >
                  Lưu và tiếp tục
                </Button>
              </div>
            ) : (
              <></>
            )}
          </div>
          {/* Form nhập */}
          <div className="bg-white w-full p-3.5 flex rounded mb-2 border border-neutral-300">
            <form className="w-full flex flex-col md:gap-x-5 gap-2">
              {/* Mã công đoạn */}
              <div className="w-full sm:flex-row sm:items-center grid sm:grid-cols-4 grid-cols-1">
                <label htmlFor="stepCode" className="font-medium text-default text-gray-700 sm:text-end">
                  Mã công đoạn
                </label>
                <div className="w-full flex flex-col col-span-3">
                  <input
                    className=" text-gray-700 border border-gray-300 sm:ml-5 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                    id="stepCode"
                    {...register('stepCode', { required: true })}
                  />
                  {errors.stepCode && (
                    <p className="text-[#ffa500] text-xs mt-2 text-start sm:ml-5">
                      Vui lòng nhập thông tin "Mã công đoạn"
                    </p>
                  )}
                </div>
              </div>

              {/* Tên công đoạn */}
              <div className="w-full sm:flex-row sm:items-center grid sm:grid-cols-4 grid-cols-1">
                <label htmlFor="stepName" className="font-medium text-default text-gray-700 sm:text-end">
                  Tên công đoạn
                </label>
                <div className="w-full flex flex-col col-span-3">
                  <input
                    className=" text-gray-700 border border-gray-300 sm:ml-5 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                    id="stepName"
                    {...register('stepName', { required: true })}
                  />
                  {errors.stepName && (
                    <p className="text-[#ffa500] text-xs mt-2 text-start sm:ml-5">
                      Vui lòng nhập thông tin "Tên công đoạn"
                    </p>
                  )}
                </div>
              </div>

              {/*Công đoạn in (Có số lượng hàng in về xưởng và ngày hàng in về xưởng) */}
              <div className="w-full sm:flex-row sm:items-center grid sm:grid-cols-4 grid-cols-1">
                <label
                  htmlFor="isRequired"
                  className="font-medium text-default flex sm:justify-end text-gray-700 sm:text-end"
                >
                  <Tooltip
                    className="flex items-center gap-1"
                    title={`Các công đoạn được check "Không bắt buộc" vẫn có thể xác nhận hoàn thành trong trường hợp không ghi nhận sản lượng`}
                  >
                    <span className="">Công đoạn bắt buộc ghi nhận sản lượng</span>
                    <HiQuestionMarkCircle className="text-primary" />
                  </Tooltip>
                </label>
                <div className="flex items-center">
                  <input
                    {...register("isRequired")}
                    className="h-4 w-4 border border-gray-300 sm:ml-5 px-3 py-1.5 focus-visible:outline-none"
                    type="radio"
                    id="batBuoc"
                    value={'true'}
                  />
                  <label className="text-default ml-1" htmlFor="batBuoc">
                    Bắt buộc
                  </label>
                  <input
                    {...register("isRequired")}
                    className="h-4 w-4 border border-gray-300 sm:ml-5 px-3 py-1.5 focus-visible:outline-none"
                    type="radio"
                    value="false"
                    id="khongBatBuoc"
                  />
                  <label className="text-default ml-1" htmlFor="khongBatBuoc">
                    Không bắt buộc
                  </label>
                </div>
              </div>
              {/*Công đoạn in (Có số lượng hàng in về xưởng và ngày hàng in về xưởng) */}
              <div className="w-full sm:flex-row sm:items-center grid sm:grid-cols-4 grid-cols-1">
                <label
                  htmlFor="isIN"
                  className="font-medium text-default flex sm:justify-end text-gray-700 sm:text-end"
                >
                  <Tooltip
                    className="flex items-center gap-1"
                    title="(Flag phân biệt công đoạn in tại Toàn Phát)"
                  >
                    <span className="">Công đoạn in</span>
                    <HiQuestionMarkCircle className="text-primary" />
                  </Tooltip>
                </label>
                <input
                  className="h-4 w-4 text-blue-600 border border-gray-300 sm:ml-5 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                  id="isIN"
                  type="checkbox"
                  {...register("isIN")}
                />
              </div>
              {/* Máy móc/chuyền */}
              <div className="w-full sm:flex-row sm:items-center grid sm:grid-cols-4 grid-cols-1">
                <label htmlFor="equipmentList" className="font-medium text-default text-gray-700 sm:text-end">
                  Máy móc/chuyền
                </label>
                <Select
                  id="equipmentList"
                  className="col-span-3 text-gray-700 border-0 sm:!ml-5 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                  mode="multiple"
                  onChange={handleSelectChange}
                  options={listEquipment}
                  allowClear
                  onClear={handleClearEquipmentList}
                />
              </div>
              {/* Công suất máy/chuyền */}
              <div className="w-full sm:flex-row sm:items-center grid sm:grid-cols-4 grid-cols-1">
                <label htmlFor="machineCapacity" className="font-medium text-default text-gray-700 sm:text-end">
                  Công suất máy/chuyền
                </label>
                <input
                  className="bg-[#eee] col-span-3 text-gray-700 border border-gray-300 sm:ml-5 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                  disabled
                  id="machineCapacity"
                  value={equipmentAndUnit.equipment > 0 ? equipmentAndUnit.equipment : ''}
                />
              </div>
              {/* Đơn vị tính công suất */}
              <div className="w-full sm:flex-row sm:items-center grid sm:grid-cols-4 grid-cols-1">
                <label htmlFor="capacityUnit" className="font-medium text-default text-gray-700 sm:text-end">
                  Đơn vị tính công suất
                </label>
                <input
                  className="bg-[#eee] col-span-3 text-gray-700 border border-gray-300 sm:ml-5 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                  disabled
                  id="capacityUnit"
                  value={equipmentAndUnit.unit}
                />
              </div>
              {/* Mô tả */}
              <div className="w-full sm:flex-row sm:items-center grid sm:grid-cols-4 grid-cols-1">
                <label htmlFor="description" className="font-medium text-default text-gray-700 sm:text-end">
                  Mô tả
                </label>
                <input
                  className="col-span-3 text-gray-700 border border-gray-300 sm:ml-5 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                  id="description"
                  {...register('description')}
                />
              </div>
              {/* Thứ tự hiển thị */}
              {/* <div className="w-full sm:flex-row sm:items-center grid sm:grid-cols-4 grid-cols-1">
                <label htmlFor="orderIndex" className="font-medium text-default text-gray-700 sm:text-end">
                  Thứ tự hiển thị
                </label>
                <input
                  className="col-span-3 text-gray-700 border border-gray-300 sm:ml-5 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                  id="orderIndex"
                  type="number"
                  {...register('orderIndex')}
                />
              </div> */}
              {/* Canh máy */}
              <div className="w-full sm:flex-row sm:items-center grid sm:grid-cols-4 grid-cols-1">
                <label htmlFor="isCM" className="font-medium text-default text-gray-700 sm:text-end">
                  Canh máy
                </label>
                <div className="flex items-center gap-8">
                  <input
                    className="h-4 w-4 text-blue-600 border border-gray-300 sm:ml-5 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                    id="isCM"
                    type="checkbox"
                    {...register("isCM")}
                  />

                  <div className="flex items-center">
                    <label htmlFor="isPrepareEquipment" className="font-medium text-default text-gray-700 sm:text-end">
                      Chuẩn bị chuyền
                    </label>
                    <input
                      className="h-4 w-4 text-blue-600 border border-gray-300 sm:ml-5 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                      id="isPrepareEquipment"
                      type="checkbox"
                      {...register("isPrepareEquipment")}
                    />
                  </div>
                </div>
              </div>
              {/* Vệ sinh */}
              <div className="w-full sm:flex-row sm:items-center grid sm:grid-cols-4 grid-cols-1">
                <label htmlFor="isVS" className="font-medium text-default text-gray-700 sm:text-end">
                  Vệ sinh
                </label>
                <input
                  className="h-4 w-4 text-blue-600 border border-gray-300 sm:ml-5 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                  id="isVS"
                  type="checkbox"
                  {...register('isVS')}
                />
              </div>
              {/* Work center Internal ID */}
              <div className="w-full sm:flex-row sm:items-center grid sm:grid-cols-4 grid-cols-1">
                <label htmlFor="workCenterInternalID" className="font-medium text-default text-gray-700 sm:text-end">
                  Work center Internal ID
                </label>
                <input
                  className="col-span-3 text-gray-700 border border-gray-300 sm:ml-5 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                  id="workCenterInternalID"
                  {...register('workCenterInternalID')}
                />
              </div>
              {/* Tên Workcenter */}
              <div className="w-full sm:flex-row sm:items-center grid sm:grid-cols-4 grid-cols-1">
                <label htmlFor="workCenterName" className="font-medium text-default text-gray-700 sm:text-end">
                  Tên Workcenter
                </label>
                <input
                  className="col-span-3 text-gray-700 border border-gray-300 sm:ml-5 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                  id="workCenterName"
                  {...register('workCenterName')}
                />
              </div>
            </form>
          </div>
        </div>
      </>
    );
  });
};

export default createRoutingOrTransfer;
